export const EVENT_ACTIONS = {
	VIEW_AUTH_POPUP: 'view_auth_popup',
	CLICK_CLOSE_AUTH_POPUP: 'click_close_auth_popup',
	CLICK_NAME_AUTH_POPUP: 'click_name_auth_popup',
	CLICK_SURNAME_AUTH_POPUP: 'click_surname_auth_popup',
	CLICK_BIRTHDAY_AUTH_POPUP: 'click_birthday_auth_popup',
	CLICK_PROMOCODE_AUTH_POPUP: 'click_promocode_auth_popup',
	CLICK_EMAIL_AUTH_POPUP: 'click_email_auth_popup',
	CLICK_PHONE_AUTH_POPUP: 'click_phone_auth_popup',
	CLICK_GETCODE_AUTH_POPUP: 'click_getcode_auth_popup',
	CLICK_ENTERPASS_AUTH_POPUP: 'click_enterpass_auth_popup',
	CLICK_ACCEPT_AUTH_POPUP: 'click_accept_auth_popup',
	CLICK_SMSCODE_AUTH_POPUP: 'click_smscode_auth_popup',
	CLICK_TINKOFF_ID_AUTH_POPUP: 'click_tinkoff_id_auth_popup',
	CLICK_SBER_ID_AUTH_POPUP: 'click_sber_id_auth_popup',
	CLICK_VK_ID_AUTH_POPUP: 'click_vk_id_auth_popup',
	CLICK_ALFA_ID_AUTH_POPUP: 'click_alfa_id_auth_popup',
	CLICK_SOVCOM_ID_AUTH_POPUP: 'click_sovcom_id_auth_popup',
	CLICK_VTB_ID_AUTH_POPUP: 'click_vtb_id_auth_popup',
	CLICK_ESIA_ID_AUTH_POPUP: 'click_esia_auth_popup',
	CLICK_YANDEX_ID_AUTH_POPUP: 'click_yandexID_auth_popup',
	CLICK_ENTER_PHONE_AUTH_POPUP: 'click_enterPhone_auth_popup',
};
